// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireFim" mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence" largeur-formulaire="85"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;